// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Start Message  */

.message-section{
    margin: 10px 0px;
    padding: 5px ;
}

.message-section .all-message-cards{
    width: 850px;
    max-width: 100%;
    /* background-color: white; */
    border-radius: 6px;
    height: 86vh;
    overflow-y: scroll;
    padding: 10px 18px;
}

.message-section .all-message-cards .message-head,
.message-section .all-message-cards .message-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    border-radius: 7px;
    margin-bottom: 10px;
    padding: 13px 15px;
}


.message-section .all-message-cards .message-head .first-cell{
    width: 5%;
}
.message-section .all-message-cards .message-head .cell{
    font-weight: 700;
}

.message-section .all-message-cards .message-head .cell ,
.message-section .all-message-cards .message-body .cell{
    width: 20%;
    background-color: white;
    border-radius: 6px;
    cursor: pointer;
}
.message-section .all-message-cards .message-head .first-cell,
.message-section .all-message-cards .message-body .first-cell
{
    width: 5%;
}

.message-section .all-message-cards .message-body .cell img {
    width: 42px;
    height: 42px;
    border-radius: 50%;
}

.message-section .all-message-cards .search-tools{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 13px ;
}

.message-section .all-message-cards .search-tools .search-bar{
    background-color: white;
    width: 280px;
    border-radius: 23px;
    padding: 5px 10px;
}

.message-section .all-message-cards .search-tools .search-bar svg{
    color: var(--gray-color); 

}

.message-section .all-message-cards .search-tools .search-bar input{
    border: none;
    width: 210px;
    margin: 0px 8px;
}
.message-section .all-message-cards .search-tools .search-bar input:focus{
    outline: none;
}

.message-section .all-message-cards .search-tools .btn-send{
    font-weight: bold;
    color: white;
    background-color: var(--main-color);
    border: none;
    border-radius: 5px;
    padding: 12px 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: .8vh;
    display: block;
    font-size: 12px;
    transition: var(--main-transition);
}

.message-section .all-message-cards .search-tools .btn-send:hover{
    opacity: .8;
}

.message-section .main-pagination{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.message-section .main-pagination .pagination-btn{
    width: 100px;
    margin: 10px 0px;
}

.message-section .main-pagination .pagination-btn button{
    color: white;
    background-color: var(--main-color); 
    border-radius: 22px;
    padding: 10px 22px;
    border: none;
}

/* .all-message-cards .filter-btn{
    background-color: var(--main-color);
    padding: 10px 22px;

    cursor: pointer;
    border-radius: 22px;
    color: white;
    border: none;
} */

.all-message-cards .filter-btn{
    background-color: transparent;

    color: var(--gray-color);
    border: none;
    cursor: pointer;
    margin: 0px 10px;
    font-size: 17px;
    outline: none;
}

 .filter-container{
    background-color: white;
    top: 50%;
    left: 50%;
    transform: translate(-50% , -50%);
    position: absolute;
    width: 440px;
    position: absolute;
    height: 210px;
    padding: 15px 18px;
    border-radius: 6px;
    outline: none;
}

.filter-container .head{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.filter-container .head h2{
    font-size: 26px;
}

.filter-container .head .close-btn {
    /* background-color: #EEE; */
    font-size: 19px;
    transition: var(--main-transition);
    color: var(--gray-color);
    border-radius: 50%;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
}

.filter-container .head .close-btn:hover{
    background-color: #EEE;
}

.filter-container .body .inputs-body{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top:14px ;
    row-gap: 10px;
}

.filter-container .body .inputs-body .input-con p{
    font-size: 14px;
    font-weight: 700;
    color: #686d77;
}

.filter-container .body .inputs-body .input-con .input-date{
    background-color: #fafafa;
    border-radius: 6px;
    display: flex;
    align-items: center;
    border: 1px solid #EEE;
    padding: 5px ;
}

.filter-container .body .inputs-body .input-con .input-date input{
    background-color: transparent;
    border: none;
}

.filter-container .body .inputs-body .input-con .input-date input:focus{
    outline: none;
}

.filter-container .body .apply-btn button {
    background-color: var(--main-color);
    display: block;
    border-radius: 6px;
    width: 100%;
    height: 34px;
    border: none;
    outline: none;
    margin: 25px 0px;
    font-weight: bold;
    cursor: pointer;
    color: white;

}



.send-message-model{
    height: 85vh !important;
}

@media(max-width:550px){
    .send-message-model{
        height: 90% !important;
    }
}


/* End Message */`, "",{"version":3,"sources":["webpack://./src/Pages/MessagesPage/messages.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;AACA;;;IAGI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;;AAE5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;;;;;;;GAQG;;AAEH;IACI,6BAA6B;;IAE7B,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;CAEC;IACG,uBAAuB;IACvB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,kCAAkC;IAClC,wBAAwB;IACxB,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,YAAY;;AAEhB;;;;AAIA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;;AAGA,gBAAgB","sourcesContent":["/* Start Message  */\n\n.message-section{\n    margin: 10px 0px;\n    padding: 5px ;\n}\n\n.message-section .all-message-cards{\n    width: 850px;\n    max-width: 100%;\n    /* background-color: white; */\n    border-radius: 6px;\n    height: 86vh;\n    overflow-y: scroll;\n    padding: 10px 18px;\n}\n\n.message-section .all-message-cards .message-head,\n.message-section .all-message-cards .message-body {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: white;\n    border-radius: 7px;\n    margin-bottom: 10px;\n    padding: 13px 15px;\n}\n\n\n.message-section .all-message-cards .message-head .first-cell{\n    width: 5%;\n}\n.message-section .all-message-cards .message-head .cell{\n    font-weight: 700;\n}\n\n.message-section .all-message-cards .message-head .cell ,\n.message-section .all-message-cards .message-body .cell{\n    width: 20%;\n    background-color: white;\n    border-radius: 6px;\n    cursor: pointer;\n}\n.message-section .all-message-cards .message-head .first-cell,\n.message-section .all-message-cards .message-body .first-cell\n{\n    width: 5%;\n}\n\n.message-section .all-message-cards .message-body .cell img {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n}\n\n.message-section .all-message-cards .search-tools{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 13px ;\n}\n\n.message-section .all-message-cards .search-tools .search-bar{\n    background-color: white;\n    width: 280px;\n    border-radius: 23px;\n    padding: 5px 10px;\n}\n\n.message-section .all-message-cards .search-tools .search-bar svg{\n    color: var(--gray-color); \n\n}\n\n.message-section .all-message-cards .search-tools .search-bar input{\n    border: none;\n    width: 210px;\n    margin: 0px 8px;\n}\n.message-section .all-message-cards .search-tools .search-bar input:focus{\n    outline: none;\n}\n\n.message-section .all-message-cards .search-tools .btn-send{\n    font-weight: bold;\n    color: white;\n    background-color: var(--main-color);\n    border: none;\n    border-radius: 5px;\n    padding: 12px 18px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: .8vh;\n    display: block;\n    font-size: 12px;\n    transition: var(--main-transition);\n}\n\n.message-section .all-message-cards .search-tools .btn-send:hover{\n    opacity: .8;\n}\n\n.message-section .main-pagination{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.message-section .main-pagination .pagination-btn{\n    width: 100px;\n    margin: 10px 0px;\n}\n\n.message-section .main-pagination .pagination-btn button{\n    color: white;\n    background-color: var(--main-color); \n    border-radius: 22px;\n    padding: 10px 22px;\n    border: none;\n}\n\n/* .all-message-cards .filter-btn{\n    background-color: var(--main-color);\n    padding: 10px 22px;\n\n    cursor: pointer;\n    border-radius: 22px;\n    color: white;\n    border: none;\n} */\n\n.all-message-cards .filter-btn{\n    background-color: transparent;\n\n    color: var(--gray-color);\n    border: none;\n    cursor: pointer;\n    margin: 0px 10px;\n    font-size: 17px;\n    outline: none;\n}\n\n .filter-container{\n    background-color: white;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50% , -50%);\n    position: absolute;\n    width: 440px;\n    position: absolute;\n    height: 210px;\n    padding: 15px 18px;\n    border-radius: 6px;\n    outline: none;\n}\n\n.filter-container .head{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.filter-container .head h2{\n    font-size: 26px;\n}\n\n.filter-container .head .close-btn {\n    /* background-color: #EEE; */\n    font-size: 19px;\n    transition: var(--main-transition);\n    color: var(--gray-color);\n    border-radius: 50%;\n    background-color: transparent;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    width: 30px;\n    height: 30px;\n}\n\n.filter-container .head .close-btn:hover{\n    background-color: #EEE;\n}\n\n.filter-container .body .inputs-body{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top:14px ;\n    row-gap: 10px;\n}\n\n.filter-container .body .inputs-body .input-con p{\n    font-size: 14px;\n    font-weight: 700;\n    color: #686d77;\n}\n\n.filter-container .body .inputs-body .input-con .input-date{\n    background-color: #fafafa;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    border: 1px solid #EEE;\n    padding: 5px ;\n}\n\n.filter-container .body .inputs-body .input-con .input-date input{\n    background-color: transparent;\n    border: none;\n}\n\n.filter-container .body .inputs-body .input-con .input-date input:focus{\n    outline: none;\n}\n\n.filter-container .body .apply-btn button {\n    background-color: var(--main-color);\n    display: block;\n    border-radius: 6px;\n    width: 100%;\n    height: 34px;\n    border: none;\n    outline: none;\n    margin: 25px 0px;\n    font-weight: bold;\n    cursor: pointer;\n    color: white;\n\n}\n\n\n\n.send-message-model{\n    height: 85vh !important;\n}\n\n@media(max-width:550px){\n    .send-message-model{\n        height: 90% !important;\n    }\n}\n\n\n/* End Message */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
